function initAgeVerification() {
  document.querySelectorAll('.age-verify-checkbox').forEach(function(checkbox) {

    // Pre-spunta solo alla prima inizializzazione:
    // se l'utente lo toglie e il drawer si aggiorna, la sua scelta resta
    if (!checkbox.dataset.avInit) {
      checkbox.checked = true;
      checkbox.dataset.avInit = '1';
    }

    // Cerca il bottone più vicino al checkbox (dentro la stessa sezione)
    var container = checkbox.closest('form, footer, .drawer__footer, .cart__recap');
    var btn = container
      ? container.querySelector('button[name="checkout"]')
      : document.querySelector('button[name="checkout"]');

    // Fallback: cerca per form id nel drawer
    if (!btn) {
      btn = document.querySelector('button[form="mini-cart-form"][name="checkout"], button.checkout-button[name="checkout"]');
    }

    if (!btn) return;

    function updateBtn() {
      btn.disabled = !checkbox.checked;
      btn.style.opacity = checkbox.checked ? '1' : '0.5';
      btn.style.cursor = checkbox.checked ? 'pointer' : 'not-allowed';
      btn.style.pointerEvents = checkbox.checked ? 'auto' : 'none';
    }

    updateBtn();

    // Evita di agganciare più listener allo stesso checkbox
    // quando la funzione viene rilanciata su cart:refresh / apertura drawer
    if (!checkbox.dataset.avBound) {
      checkbox.addEventListener('change', updateBtn);
      checkbox.dataset.avBound = '1';
    }
  });
}

document.addEventListener('DOMContentLoaded', initAgeVerification);
document.addEventListener('cart:refresh', initAgeVerification);
document.addEventListener('cart:updated', initAgeVerification);

// Rilancia quando il drawer viene aperto
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-action="open-cart"], .js-mini-cart-toggle, [aria-controls="mini-cart"]')) {
    setTimeout(initAgeVerification, 300);
  }
});